<template lang="pug">
.story-publications
  StoryPublication(
    v-for="publication in publications"
    :story-id="storyId"
    :publication="publication"
    :key="publication.id"
    v-if="!storyPubsLoading"
  )
</template>

<script>
import { mapStores, mapState } from 'pinia'
import { usePublicationsStore } from '@/stores/publications'
import StoryPublication from './story_publication.vue'

export default {
  components: {
    StoryPublication
  },

  props: {
    storyId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      // The StoryPublication component needs Publication and StoryPublication
      // data, so we need to wait until both are fetched before rendering
      storyPubsLoading: true
    }
  },

  computed: {
    ...mapStores(usePublicationsStore),
    ...mapState(usePublicationsStore, ['publications'])
  },

  async mounted() {
    await this.publicationsStore.fetchOnce()

    await this.$store.dispatch('storyPublications/fetch', { storyId: this.storyId }).then(() => {
      this.storyPubsLoading = false
    })
  }
}
</script>
